import script from "./ClassMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassMaterial.vue?vue&type=script&setup=true&lang=js"

import "./ClassMaterial.vue?vue&type=style&index=0&id=5e817762&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e817762"]])

export default __exports__